import { render } from "./Perfil.vue?vue&type=template&id=380b2748"
import script from "./Perfil.vue?vue&type=script&lang=ts"
export * from "./Perfil.vue?vue&type=script&lang=ts"
script.render = render

export default script